import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LOCALE, type Locale } from "./locales";

import enAuth from "../../locales/en/auth.json";
import enCharts from "../../locales/en/charts.json";
import enCommon from "../../locales/en/common.json";
import enDashboard from "../../locales/en/dashboard.json";
import enDesk from "../../locales/en/desk.json";
import enErrors from "../../locales/en/errors.json";
import enMedals from "../../locales/en/medals.json";
import enNav from "../../locales/en/nav.json";
import enTally from "../../locales/en/tally.json";

export { intlLocaleFor, SUPPORTED_LOCALES, type Locale } from "./locales";

/**
 * MSES is English only: these bundles are every string the app shows, and the
 * source `types.d.ts` derives the typed t() keys from.
 *
 * Adding a namespace: create `locales/en/<ns>.json`, import it here, add it
 * to EN_RESOURCES and to `types.d.ts`.
 */
export const EN_RESOURCES = {
	auth: enAuth,
	charts: enCharts,
	common: enCommon,
	dashboard: enDashboard,
	desk: enDesk,
	errors: enErrors,
	medals: enMedals,
	nav: enNav,
	tally: enTally,
} as const;

/** The active locale for anything outside React: always English. */
export function currentLocale(): Locale {
	return DEFAULT_LOCALE;
}

/** Runs before the first render (main.tsx) so no frame paints untranslated. */
export async function initI18n(): Promise<void> {
	await i18n.use(initReactI18next).init({
		lng: DEFAULT_LOCALE,
		fallbackLng: DEFAULT_LOCALE,
		ns: Object.keys(EN_RESOURCES),
		defaultNS: "common",
		resources: { en: EN_RESOURCES },
		interpolation: { escapeValue: false }, // React escapes already
		react: { useSuspense: false }, // init awaits the bundles instead
		returnNull: false,
	});
	document.documentElement.lang = DEFAULT_LOCALE;
}

export { i18n };
